import React, { useEffect, useState } from "react";
import { CommentFeed } from "components/Comments/CommentFeed";
import { IComment } from "interfaces/comment";
import { useReadProjectComments } from "hooks/comments/project/useReadProjectComments";
import { useWriteProjectComment } from "hooks/comments/project/useWriteProjectComment";

interface ProjectCommentSectionProps {
  projectId: number;
}

export const ProjectCommentSection = ({
  projectId
}: ProjectCommentSectionProps): JSX.Element => {
  const [comments, setComments] = useState<IComment[]>([]);

  const {
    loading: commentsListLoading,
    getProjectComments
  } = useReadProjectComments(projectId);

  async function onCommentsChanged(): Promise<void> {
    setComments(await getProjectComments());
  }

  const {
    createProjectComment,
    updateProjectComment,
    deleteProjectComment
  } = useWriteProjectComment(projectId, onCommentsChanged);

  useEffect(() => {
    onCommentsChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <CommentFeed
      loading={commentsListLoading}
      comments={comments}
      addComment={createProjectComment}
      updateComment={updateProjectComment}
      deleteComment={deleteProjectComment}
    />
  );
};
